import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';
import { S_Link } from '../../../../../../design/links/S_Link';
import { S_InfoModal } from '../../../../../../design/modals/infoModal/S_InfoModal';
import { useExportDataBl } from '../../ExportData.bl';
import { IExportDataStore } from '../../ExportData.store';

export const DownloadExportModal = observer((): ReactElement => {
  const { t } = useTranslator();
  const bl = useExportDataBl();
  const store = useInjection(IExportDataStore.$);

  const [downloadLink, setDownloadLink] = useState<string>('');

  useEffect(() => {
    if (store.showDownloadModal) {
      bl.getProjectExportDownloadUrl(store.downloadProjectExportId, store.downloadDataFilter)
        .then((downloadLink) => {
          setDownloadLink(downloadLink);
        })
        .catch((error: unknown) => {
          console.error('Failed to generate download link:', error);
        });
    }
  }, [store.showDownloadModal]);

  useEffect(() => {
    if (downloadLink) {
      window.open(downloadLink, '_self');

      setTimeout(() => {
        handleHide();
      }, 59 * 1000);
    }
  }, [downloadLink]);

  const handleHide = (): void => {
    bl.hideDownloadModal();
  };

  const handleDownload = (): Window | null => window.open(downloadLink, '_blank');

  return (
    <S_InfoModal
      buttonText={t('ok')}
      toggle={handleHide}
      onClick={handleHide}
      headerText={t('new.projects.details.export_data.download_modal.modal_header')}
      isOpen={store.showDownloadModal}
    >
      {t('new.projects.details.export_data.download_modal.modal_body1')}
      <span>
        {t('new.projects.details.export_data.download_modal.modal_body2')}{' '}
        {downloadLink && (
          <S_Link
            color='anchor'
            onClick={handleDownload}
          >
            {t('new.projects.details.export_data.download_modal.direct_download_link')}
          </S_Link>
        )}
      </span>
    </S_InfoModal>
  );
});
